import {
  createBrowserAnalytics,
  observeAnalytics,
  productScreen,
} from "@hereby/components/analytics";
import Alpine from "alpinejs";
export const analytics = createBrowserAnalytics("module_manager", import.meta.env);
const observed = new WeakSet<object>();
export function observeAppAnalytics(owner: object, readState: () => string | undefined) {
  if (observed.has(owner)) {
    return;
  }
  observed.add(owner);
  observeAnalytics(Alpine, analytics, () => {
    const store = Alpine.store("hereby");
    const router = Alpine.store("router");
    return {
      screen: store.isLoading
        ? undefined
        : productScreen("module_manager", router.path, store.authenticated, readState()),
      context: [
        store.authenticated,
        store.currentUser?.id,
        store.currentUser?.organizationId,
        store.account?.id,
      ],
    };
  });
}
